import LayoutNav from "../../components/layout/LayoutNav";
import SubHeader from "../../components/elements/SubHeader";
import SectionBox from "../../components/section-box/SectionBox";
import ListContent from "../../components/plan-detail/list-content/ListContent";
import ListApporvals from "../../components/plan-detail/box-approvals/ListApporvals";
import ListActivities from "../../components/plan-detail/box-activities/ListActivities";
import BarChartDetail from "../../components/plan-detail/chart-bar/BarChartDetail";
import BoxNotes from "../../components/plan-detail/box-notes/BoxNotes";
import { useLoaderData } from "react-router-dom";
import EmptyBox from "../../components/emptystate/EmptyBox";
import { Link } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { getAnnotations } from "../../services/agendas.service";
import ListActions from "../../components/plan-detail/action-item/ListActions";
import CrudApprovalPopup from "../../components/popups/plan-compile/CrudApprovalPopup";
import { getActivitiesList } from "../../services/activities.service";
import { deletePlanApproval, getPlanApprovals } from "../../services/plans.service";
import useCalendly from "../../hooks/calenldy.hook";
import LoadingBox from "../../components/loading/LoadingBox";
import PlanDownloadModal from "../../components/popups/PlanDownloadPopup";
import { formatOrganizationPlanDownloadObject } from "../../helper/formatter.helper";
import { ARRAY_STATUS_ICON } from "../../helper/common.helper";
import AnnualReportPopup from "../../components/popups/AnnualReportPopup";
import CreateTaskModal from "../../components/popups/task/CreateTaskPopup";
import { useSessionStore } from "../../store/session.store";
import ConfirmModal from "../../components/popups/ConfirmPopup";
import useDateFormatter from "../../hooks/date-formatter.hook";
import useNotification from "../../hooks/notification.hook";
import { getTodoTdLink } from "../../lib/utils";

const initIsInit = {
	approvalsDelete: false,
	approvals: false,
	annotations: false,
	activities: false,
};

const initDeleteModalProps = {
	open: false,
	data: null,
};

function PlanDetail({ userRole: role = "admin" }) {
	const { planData } = useLoaderData();
	const { openNotification, helperErrorNotification } = useNotification();
	const { formatDate } = useDateFormatter();
	const { user } = useSessionStore();
	const isApprovalDeleteAllowed = useMemo(
		() => ["admin", "reseller"].includes(user?.role),
		[user?.role]
	);

	const [annotations, setAnnotations] = useState([]);

	const [openPrinterModal, setOpenPrinterModal] = useState(false);

	const [isCreateTaskOpen, setIsCreateTaskOpen] = useState(false);

	const [planTodoCounter, setPlanTodoCounter] = useState(planData?.todo_count ?? 0);

	const [isAnnualReportOpen, setIsAnnualReportOpen] = useState(false);

	const [activities, setActivities] = useState([]);

	const [isInit, setIsInit] = useState(initIsInit);

	const [isLoading, setIsLoading] = useState(initIsInit);

	const [approvals, setApprovals] = useState([]);

	const [approvalOpen, setApprovalOpen] = useState(false);
	const [approvalSelected, setApprovalSelected] = useState(null);

	const [deleteModalProps, setDeleteModalProps] = useState(initDeleteModalProps);

	const { openCalendly } = useCalendly();

	useEffect(() => {
		if (role === "admin") {
			if (planData?.agenda) getListAnnotation();
			else {
				setIsInit((i) => ({ ...i, annotations: true }));
			}
		}

		getListActivities();
	}, []);

	useEffect(() => {
		getListApprovals();
	}, []);

	/**
	 * Get Annotations list
	 */
	const getListAnnotation = () => {
		setIsLoading((l) => ({ ...l, annotations: true }));

		getAnnotations(
			{ id: planData.agenda.id, idCorp: planData.organization_id },
			(res) => {
				setIsInit((i) => ({ ...i, annotations: true }));

				setIsLoading((l) => ({ ...l, annotations: false }));

				setAnnotations(res.data);
			},
			() => setIsLoading((l) => ({ ...l, annotations: false }))
		);
	};

	/**
	 * Get Approvals list
	 */
	const getListApprovals = () => {
		setIsLoading((l) => ({ ...l, approvals: true }));

		getPlanApprovals(
			{ idCorp: planData.organization_id, idPlan: planData.id },
			(res) => {
				setIsLoading((l) => ({ ...l, approvals: false }));

				setIsInit((i) => ({ ...i, approvals: true }));

				setApprovals(res.data);
			},
			() => setIsLoading((l) => ({ ...l, approvals: false }))
		);
	};

	/**
	 * Get Annotations list
	 */
	const getListActivities = () => {
		setIsLoading((l) => ({ ...l, activities: true }));

		getActivitiesList(
			{ idPlan: planData.id, idCorp: planData.organization_id },
			(res) => {
				setIsLoading((l) => ({ ...l, activities: false }));

				setIsInit((i) => ({ ...i, activities: true }));

				setActivities(res.data);
			},
			() => setIsLoading((l) => ({ ...l, activities: false }))
		);
	};

	const countEditDocs = planData.organization_chapters.reduce(
		(a, c) =>
			a + c.organization_chapter_contents.filter((c) => c.template_chapter_content.editable).length,
		0
	);

	const counterAttachmentsRequirements = planData.organization_chapters.reduce(
		(a, c) =>
			a +
			(c?.organization_goals.reduce(
				(a, g) => a + (g?.organization_requirements_attachments_count ?? 0),
				0
			) ?? 0),
		0
	);

	const counterAttachmentsPlan = planData?.attachments?.length ?? 0;

	const linksCompile = {
		admin: `/admin/entities/entity/${planData.organization_id}/plan/${planData.id}/compile`,
		reseller: `/reseller/${planData.organization_id}/plan/${planData.id}/compile`,
		organization: `/organization/plan/${planData.id}/compile`,
	};

	const linksPresets = {
		admin: `/admin/plans/template/${planData.template_plan_id}/presets`,
		reseller: `/reseller/presets/${planData.organization_id}/${planData.id}`,
	};

	/**
	 * Template subheader
	 * @returns
	 */
	const templateSubheader = () => {
		if (["admin", "reseller"].includes(role))
			return (
				<div className="flex gap-5 items-center">
					<button
						type="button"
						className="button line small primary"
						onClick={() => setIsAnnualReportOpen(true)}
					>
						Genera relazione annuale
					</button>

					<Link to={linksCompile[role]} className="button fill small interactive">
						<span className="icon_24 default in_entity icon_mask !bg-white -my-1"></span>
						Accedi come Ente
					</Link>
				</div>
			);

		if (role === "reseller")
			return (
				<Link to={linksCompile.reseller} className="button fill small secondary">
					<span className="icon_24 default wrench icon_mask -ml-2 !bg-primary-100"></span>
					Compila piano
				</Link>
			);

		if (role === "organization")
			return (
				<Link to={linksCompile.organization} className="button fill small secondary">
					<span className="icon_24 default wrench icon_mask -ml-2 !bg-primary-100"></span>
					Compila piano
				</Link>
			);
	};

	/**
	 *
	 * @param item
	 */
	const openApprovalPopup = (approval = null) => {
		setApprovalSelected(approval);
		setApprovalOpen(true);
	};

	/**
	 * Approval • open confirm modal delete
	 * @param approval
	 */
	const openApprovalDeletePopup = (approval = null) => {
		setDeleteModalProps({
			open: true,
			data: approval,
		});
	};

	/**
	 * Approval • delete
	 * @param idApproval
	 * @returns {Promise<void>}
	 */
	const handleDeleteApproval = async () => {
		if (isLoading.approvalsDelete) return;

		setIsLoading((l) => ({ ...l, approvalsDelete: true }));
		const params = {
			idCorp: planData.organization_id,
			idPlan: planData.id,
			idApproval: deleteModalProps.data.id,
		};

		// Api call
		await deletePlanApproval(
			params,
			(response) => {
				setIsLoading((l) => ({ ...l, approvalsDelete: false }));
				setDeleteModalProps(initDeleteModalProps);
				openNotification({
					text: "Adozione rimossa con successo!",
					status: "success",
				});

				// Approvals • get list
				getListApprovals();
			},
			(error) => {
				setIsLoading((l) => ({ ...l, approvalsDelete: false }));
				helperErrorNotification(error);
			}
		);
	};

	const downloadTemplate = formatOrganizationPlanDownloadObject(planData.organization_contents);

	const linkTasks = getTodoTdLink({
		templatePlanId: planData.template_plan_id,
		organizationId: role !== "organization" && planData.organization_id,
	});

	return (
		<LayoutNav withSubheader>
			<SubHeader
				title={planData?.template_plan?.name}
				sublogo={planData.organization.logo_url ? planData.organization.logo_url : null}
				subtitle={role !== "organization" && planData.organization.name}
				back
				TemplateRightContent={templateSubheader}
			/>

			<div className="main_page_box">
				<div className="grid_page_right_side">
					<div className="left_content">
						<SectionBox title="Cosa vuoi fare?" layout="unboxed">
							<ListActions>
								{/* Action Approve */}
								<ListActions.Item
									title="Adotta il piano"
									icon="piano"
									description="Non serve che le linee d'azione siano tutte completate ma è fondamentale che tutte siano state prese in carico."
									actionTemplate={() => (
										<button
											type="button"
											className="button ligth_green small fill"
											onClick={() => openApprovalPopup()}
										>
											<span className="icon_24 default approved icon_mask !bg-success-100"></span>
											Adotta il piano
										</button>
									)}
								/>

								<ListActions.Item
									title="Gestisci le attività del piano"
									icon="task"
									description="Crea nuove attività o consulta l’elenco di quelle esistenti."
									actionTemplate={() => (
										<div className="flex gap-[12px]">
											<a
												href={linkTasks}
												rel="noopener noreferrer"
												target="_blank"
												className="button small fill primary"
											>
												<span className="icon_24 default link_out icon_mask !bg-white"></span>
												Vedi le attvità
												<div className="bg-white text-primary-100 rounded-full text-10 leading-[8px] font-bold size-[14px] flex items-center justify-center ml-2">
													{planTodoCounter > 99 ? "+99" : planTodoCounter}
												</div>
											</a>

											<button
												type="button"
												className="button small line"
												onClick={() => setIsCreateTaskOpen(true)}
											>
												<span className="icon_24 default plus"></span>
												Crea attività
											</button>
										</div>
									)}
								/>

								{/* Action Booking */}
								{["admin", "reseller"].includes(role) && (
									<ListActions.Item
										title="Configurazioni di stampa"
										icon="wrench"
										description="Gestisci le configurazioni di stampa: la selezione degli stati, l'inclusione dello scadenziario e adozioni, la selezione dei contenuti da includere"
										actionTemplate={() => (
											<Link className="button small line" to={linksPresets[role]}>
												<span className="icon_24 default settings"></span>
												Gestisci configurazioni
											</Link>
										)}
									/>
								)}

								{/* Action Booking */}
								{(role === "admin" || (role === "organization" && user?.fad_id)) && (
									<ListActions.Item
										title="Verifica il piano con l’esperto"
										icon="support"
										description="Prenota il tuo appuntamento per discutere le linee d'azione del tuo piano."
										actionTemplate={() => (
											<button type="button" className="button small line" onClick={openCalendly}>
												<span className="icon_24 default link_out"></span>
												Prenota appuntamento
											</button>
										)}
									/>
								)}

								{/* Action Booking */}
								<ListActions.Item
									title="Genera il documento per la stampa"
									icon="printer"
									description="Non serve che le linee d'azione siano tutte completate ma è fondamentale che tutte siano state prese in carico."
									actionTemplate={() => (
										<button
											type="button"
											className="button small line"
											onClick={() => setOpenPrinterModal(true)}
										>
											<span className="icon_24 default doc"></span>
											Genera documento
										</button>
									)}
								/>
							</ListActions>
						</SectionBox>

						<SectionBox title="Contenuto del piano" layout="unboxed">
							<ListContent className="xl:!grid xl:grid-cols-2">
								<ListContent.Box
									counter={planData.organization_chapter_contents_count}
									icon="doc"
									isToComplete={true}
									title="documenti testuali"
									lineDescriptions={[
										{
											desc: "modificabili",
											counter: countEditDocs,
										},
										{
											desc: "da visualizzare",
											counter: planData.organization_chapter_contents_count - countEditDocs,
										},
									]}
								/>

								<ListContent.Box
									counter={planData.organization_goals_count}
									icon="layers"
									isToComplete={true}
									title="obiettivi"
									lineDescriptions={[
										{
											desc: "nuovi",
											counter: planData.template_goals_statuses.find((el) => el.status === "new")
												.count,
											icon: "icon_16 default megaphone icon_mask !bg-secondary-100",
										},
										{
											desc: "aggiornati",
											counter: planData.template_goals_statuses.find(
												(el) => el.status === "modified"
											).count,
											icon: "icon_16 default update icon_mask !bg-secondary-100",
										},
									]}
								/>

								<ListContent.Box
									counter={planData.organization_requirements_count}
									icon="layer"
									isToComplete={true}
									title="linee d'azione"
									lineDescriptions={[
										{
											desc: "nuove",
											counter: planData.template_requirements_statuses.find(
												(el) => el.status === "new"
											).count,
											icon: "icon_16 default megaphone icon_mask !bg-secondary-100",
										},
										{
											desc: "aggiornate",
											counter: planData.template_requirements_statuses.find(
												(el) => el.status === "modified"
											).count,
											icon: "icon_16 default update icon_mask !bg-secondary-100",
										},
									]}
								/>

								<ListContent.Box
									counter={counterAttachmentsPlan + counterAttachmentsRequirements}
									icon="paper_clip"
									isToComplete={true}
									title="Allegati"
									lineDescriptions={[
										{
											desc: "del piano",
											counter: counterAttachmentsPlan,
										},
										{
											desc: "delle linee d'azione",
											counter: counterAttachmentsRequirements,
										},
									]}
								/>
							</ListContent>
						</SectionBox>

						<SectionBox title="Andamento">
							<BarChartDetail
								completePercentage={planData.completion_percentage}
								data={planData.organization_requirements_statuses.map((status) => ({
									value: status.count,
									color: ARRAY_STATUS_ICON.find((s) => s.icon === status.icon)?.color ?? "",
									label: status.name.toLowerCase(),
								}))}
							/>
						</SectionBox>

						{role === "admin" && (
							<SectionBox title="Annotazioni">
								<div className="relative">
									{annotations.length > 0 ? (
										<BoxNotes
											notes={annotations.slice(0, 5)}
											organizationId={planData.organization_id}
										/>
									) : (
										isInit.annotations && (
											<EmptyBox
												icon="icon_75 default archive_note"
												title="Nessun annotazione"
												description="Non ci sono annotazioni per questo piano"
											/>
										)
									)}

									{isLoading.annotations && <LoadingBox blocked={!isInit.annotations} />}
								</div>
							</SectionBox>
						)}
					</div>

					<div className="right_content">
						<SectionBox title="Storico adozioni" layout={approvals.length > 0 ? "unboxed" : ""}>
							<div className="relative">
								{approvals.length > 0 ? (
									<div className="fade_in">
										<ListApporvals
											list={approvals.slice(0, 5)}
											planData={planData}
											onEdit={openApprovalPopup}
											onDelete={isApprovalDeleteAllowed && openApprovalDeletePopup}
										/>
									</div>
								) : (
									isInit.approvals && (
										<EmptyBox
											icon="icon_75 default approvals"
											title="Nessun adozione"
											description="Non ci sono adozioni per questo piano"
										/>
									)
								)}

								{isLoading.approvals && <LoadingBox blocked={!isInit.approvals} />}
							</div>
						</SectionBox>

						<SectionBox title="Log attività">
							<div className="relative">
								{activities.length > 0 ? (
									<div className="fade_in">
										<ListActivities list={activities.slice(0, 8)} />
									</div>
								) : (
									isInit.activities && (
										<EmptyBox
											icon="icon_75 default no_activities"
											title="Nessun log attività"
											description="Non si sono verificate attivà per questo piano"
										/>
									)
								)}
								{isLoading.activities && <LoadingBox blocked={!isInit.activities} />}
							</div>
						</SectionBox>
					</div>
				</div>
			</div>

			<CrudApprovalPopup
				open={approvalOpen}
				plan={planData}
				approval={approvalSelected}
				setOpen={setApprovalOpen}
				onSuccess={getListApprovals}
			/>

			<ConfirmModal
				open={deleteModalProps.open}
				setOpen={() => setDeleteModalProps(initDeleteModalProps)}
				title="Conferma eliminazione"
				icon="icon_16 default quotes"
				subtitle={`Adozione del ${formatDate(deleteModalProps.data?.date, "DD MMM YYYY")}`}
				description={`${deleteModalProps.data?.note}`}
				alertMessage="Attenzione! Questa operazione è irreversibile! <b>Sei sicuro di procedere?</b>"
				ctaLabel="Elimina"
				isLoading={isLoading.approvalsDelete}
				onConfirm={handleDeleteApproval}
			/>

			<PlanDownloadModal
				open={openPrinterModal}
				setOpen={setOpenPrinterModal}
				template={downloadTemplate}
				idOrganization={planData.organization_id}
				idPlan={planData.id}
				statuses={planData.organization_requirements_statuses}
				templateId={planData.template_plan_id}
			/>

			{["admin", "reseller"].includes(role) && (
				<AnnualReportPopup
					open={isAnnualReportOpen}
					setOpen={setIsAnnualReportOpen}
					organizationPlan={planData}
					statuses={planData.organization_requirements_statuses}
				/>
			)}

			<CreateTaskModal
				organizationId={planData.organization_id}
				open={isCreateTaskOpen}
				bodyParams={{ organization_plan_id: planData.id }}
				setOpen={setIsCreateTaskOpen}
				onInsert={() => setPlanTodoCounter((c) => c + 1)}
			/>
		</LayoutNav>
	);
}

export default PlanDetail;
